import {sum as Rsum} from 'ramda'
import type {Branded} from '@kapitalist/utils/Branded'
import type {NEList} from '@kapitalist/utils/NEList'
import type {TMillions} from '../../types/millions'

export class MillionsMath {
  static sum(...values: TMillions[]): TMillions
  static sum(values: TMillions[]): TMillions
  static sum<T extends Branded<number, symbol>>(value: T | T[], ...values: T[]): T {
    return Rsum([...(value instanceof Array ? value : [value]), ...values]) as T
  }

  static subtract(a: TMillions, b: TMillions): TMillions
  static subtract<
    T extends Branded<number, symbol>,
    U extends Branded<number, symbol>,
  >(a: T, b: U): T {
    return (a - b) as T
  }

  static min(first: TMillions, ...rest: TMillions[]): TMillions
  static min(values: NEList<TMillions>): TMillions
  static min<T extends Branded<number, symbol>>(value: T | T[], ...values: T[]): T {
    return Math.min(...(value instanceof Array ? value : [value]), ...values) as T
  }
}
